<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Startup Search</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">In the “Startup search” section, you can perform the same advanced search described for the Chatbot (see dedicated paragraph).

In the top text bar, you can write the query and then press the green “Search startup” button to start the search.

You can visualize the first 10 results in order of relevance and you can have more details about a startup by clicking on its name.


</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "StartupSearchHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>